import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=e756335e&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=e756335e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e756335e",
  null
  
)

export default component.exports